import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsMghabitat(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsMghabitat(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsMghabitat - ', e);
                throw e;
            });
    };
}
export { getLogsMghabitat };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsMghabitat/actions.js